import type * as THREE from "three";

const DETAIL_PREFIX = "detail/";

/**
 * The engine name a mesh is filed under: its own `detail/…` name, or the
 * nearest named ancestor's (imported GLB modules keep their authoring names
 * on inner meshes and carry the `detail/premium/…` name on their root).
 */
export function resolveAssemblyMeshName(object: THREE.Object3D): string | null {
	let current: THREE.Object3D | null = object;
	while (current) {
		if (current.name.startsWith(DETAIL_PREFIX)) return current.name;
		current = current.parent;
	}
	return null;
}
